package fr.manyverse.app.presentation.components.premade

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Button
import androidx.compose.material3.Checkbox
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import fr.manyverse.app.domain.model.GmInventoryItem
import fr.manyverse.app.presentation.components.checkboxToggleable
import manyverse.shared.generated.resources.Res
import manyverse.shared.generated.resources.cancel
import manyverse.shared.generated.resources.gm_inventory_empty
import manyverse.shared.generated.resources.premade_import_from_chest_title
import manyverse.shared.generated.resources.premade_import_items
import org.jetbrains.compose.resources.stringResource

/**
 * Popup listant les objets du coffre MJ avec une case à cocher chacun. Le bouton « Importer »
 * n'est actif que si au moins un objet est coché. Remonte les objets choisis via [onImport].
 */
@Composable
fun ImportItemsFromChestDialog(
    chestItems: List<GmInventoryItem>,
    getSignedImageUrl: suspend (String) -> String?,
    onImport: (List<GmInventoryItem>) -> Unit,
    onDismiss: () -> Unit,
) {
    var selectedIds by remember { mutableStateOf(emptySet<String>()) }

    AlertDialog(
        onDismissRequest = onDismiss,
        title = { Text(stringResource(Res.string.premade_import_from_chest_title)) },
        text = {
            if (chestItems.isEmpty()) {
                Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                    Text(
                        text = stringResource(Res.string.gm_inventory_empty),
                        style = MaterialTheme.typography.bodyMedium,
                        color = MaterialTheme.colorScheme.onSurfaceVariant,
                        textAlign = TextAlign.Center
                    )
                }
            } else {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .heightIn(max = 420.dp)
                        .verticalScroll(rememberScrollState()),
                    verticalArrangement = Arrangement.spacedBy(12.dp)
                ) {
                    chestItems.forEach { item ->
                        var signedUrl by remember(item.id) { mutableStateOf<String?>(null) }
                        LaunchedEffect(item.imageUrl) {
                            signedUrl = item.imageUrl?.let { getSignedImageUrl(it) }
                        }
                        val checked = item.id in selectedIds
                        PreMadeInventoryRow(
                            name = item.name,
                            category = item.category,
                            quantity = item.quantity,
                            signedImageUrl = signedUrl,
                            modifier = Modifier.checkboxToggleable(
                                checked = checked,
                                onCheckedChange = { isChecked ->
                                    selectedIds = if (isChecked) selectedIds + item.id
                                    else selectedIds - item.id
                                }
                            )
                        ) {
                            Checkbox(checked = checked, onCheckedChange = null)
                        }
                    }
                }
            }
        },
        confirmButton = {
            Button(
                onClick = { onImport(chestItems.filter { it.id in selectedIds }) },
                enabled = selectedIds.isNotEmpty()
            ) {
                Text(stringResource(Res.string.premade_import_items))
            }
        },
        dismissButton = {
            TextButton(onClick = onDismiss) {
                Text(stringResource(Res.string.cancel))
            }
        }
    )
}
